import { render, staticRenderFns } from "./WorkerList976.vue?vue&type=template&id=0edf9a28&scoped=true"
import script from "./WorkerList976.vue?vue&type=script&lang=js"
export * from "./WorkerList976.vue?vue&type=script&lang=js"
import style0 from "./WorkerList976.vue?vue&type=style&index=0&id=0edf9a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf9a28",
  null
  
)

export default component.exports